module.exports = __webpack_public_path__ + "static/media/S (155).40a5bc09.jpg";